import NiceSelect from 'nice-select2/src/js/nice-select2';

export default class Selects {
    constructor() {
        this.init();
    }

    init() {
        document.querySelectorAll('.form-select').forEach((selectElement) => {
            if (selectElement.niceSelectInstance) {
                selectElement.niceSelectInstance.destroy();
            }

            const placeholder = selectElement.getAttribute('placeholder') || "<?php _e('Choisissez une option', 'basic'); ?>";

            const niceSelectInstance = new NiceSelect(selectElement, {
                searchable: false,
                placeholder,
            });

            selectElement.niceSelectInstance = niceSelectInstance;
            selectElement.classList.add('nice-select-initialized');

            const niceSelect = selectElement.nextElementSibling;
            if (niceSelect && niceSelect.classList.contains('nice-select')) {
                const current = niceSelect.querySelector('.current');
                const setPlaceholderClass = () => {
                    if (current.textContent.trim() === placeholder) {
                        niceSelect.classList.add('is-placeholder');
                    } else {
                        niceSelect.classList.remove('is-placeholder');
                    }
                };

                setPlaceholderClass();

                niceSelect.addEventListener('click', (e) => {
                    setTimeout(setPlaceholderClass, 10);
                });
            }
        });
    }
}

